import type { Variant } from '~/modules/campaign/types';

/** What a typed URL can fail on, in the order the field checks them. */
export const VARIANT_URL_REDIRECT_FIELD_ERROR_CODE = {
  INVALID_URL: 'INVALID_URL',
  NOT_AVAILABLE_ON_ONLINE_STORE: 'NOT_AVAILABLE_ON_ONLINE_STORE',
  SELECTED_IN_CAMPAIGN: 'SELECTED_IN_CAMPAIGN',
  SELECTED_IN_OTHER_CAMPAIGN: 'SELECTED_IN_OTHER_CAMPAIGN',
  /** The lookup itself failed, so nothing is known about the URL yet. */
  LOOKUP_FAILED: 'LOOKUP_FAILED',
} as const;

export type IVariantUrlRedirectFieldErrorCode =
  (typeof VARIANT_URL_REDIRECT_FIELD_ERROR_CODE)[keyof typeof VARIANT_URL_REDIRECT_FIELD_ERROR_CODE];

/** Inline shortcut a message offers, opening whatever has to change for the URL to qualify. */
export interface IVariantUrlRedirectFieldErrorAction {
  /** Reads as "Edit product", "Edit visibility", "Edit experiment". */
  label: string;
  onAction: () => void;
}

export interface IVariantUrlRedirectFieldError {
  code: IVariantUrlRedirectFieldErrorCode;
  /** Side of the experiment already holding this URL — "Already selected for Variant". */
  variantLabel?: string;
  action?: IVariantUrlRedirectFieldErrorAction;
}

export interface IConfirmTypedVariantUrlParams {
  url: string;
  /** Side the URL is being confirmed for — Control can only take a page already live. */
  variant: Variant;
}

/** Resolves a typed URL against every check; resolves undefined once it passes them all. */
export type IConfirmTypedVariantUrl = (
  params: IConfirmTypedVariantUrlParams,
) => Promise<IVariantUrlRedirectFieldError | undefined>;
